import {Separator} from '../constants';

/**
 * @deprecated It will be removed in 6 months 07-14-2026.
 * New code should use direct separator strings. This utility is only for backward compatibility.
 *
 * @description
 * Converts legacy enum-based separator format ('COMMA', 'PERIOD', etc.) to actual separator character.
 * If the input is already a separator character, returns it as-is.
 *
 * @param format - Separator format (enum value like 'COMMA' or direct string like ',')
 * @returns Actual separator character
 *
 * @example
 * normalizeSeparatorFormat('COMMA') // returns ','
 * normalizeSeparatorFormat(',')     // returns ','
 * normalizeSeparatorFormat('/')     // returns '/'
 */
export function normalizeSeparatorFormat(format: string): string {
    const separatorValues = Object.values(Separator);

    // If already a separator character (not an enum key), use as-is
    if (separatorValues.includes(format)) {
        return format;
    }

    // Try to look up enum value, fallback to format itself for unknown values
    return Separator[format as keyof typeof Separator] || format;
}
